import { Navigate } from "react-router";

import { useEvaluation } from "@/hooks/useEvaluation/useEvaluation";
import { getRevieweeUserId } from "../EvaluationNew/EvaluationNew.utils";
import { EvaluationUpdateForm } from "../EvaluationUpdateForm";

import { useCall } from "@/hooks/useCall/useCall";
import { useCcAccess } from "@/hooks/useCcAccess/useCcAccess";

export function EvaluationEdit() {
  const { canEdit } = useCcAccess();

  const { call } = useCall();

  const { evaluation, loading } = useEvaluation(call?.id);

  const revieweeUserId = getRevieweeUserId(call);

  if (!canEdit || (!loading && !evaluation) || !revieweeUserId) {
    // direct to the main route `/calls/:callId/evaluation`
    return <Navigate to="../" />;
  }

  return evaluation ? (
    <EvaluationUpdateForm
      revieweeUserId={revieweeUserId}
      evaluation={evaluation}
    />
  ) : null;
}
